import { SkaldElement, SkaldValue } from '@skaldaura/devkit'
import ProjetCarousel from 'components/carousel/projetsCarousel'
import PagesReader from 'components/pagesReader/pagesReader'
import CounterContext from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect, useState } from 'react'
import Popup from 'reactjs-popup'

export interface IPoppulatedMag {
   mois?:SkaldValue[],
   pages?:SkaldValue[]
}

interface IProps {
   element: SkaldElement
}

export default function AptarMag({element}:IProps) {
   const { setCounter, counterDefault } = useContext(CounterContext)
   const { setHeadband } = useContext(HeadbandContext)
   const [mags, setMags] = useState<IPoppulatedMag[]>([])
   const [activeMag, setActiveMag] = useState<IPoppulatedMag>()
   const [open, setOpen] = useState(false)

   const closeModal = () => setOpen(false)
   const openModal = () => setOpen(true)

   useEffect(() => {
      element.getPopulatedSubgroups("Aptar Mag")
      .then((mags:IPoppulatedMag[]) => {
         const sorted = mags.sort((a, b) => {
            return a.mois && b.mois ? new Date(b.mois[0].value).getTime() - new Date(a.mois[0].value).getTime() : 0
         })
         setMags([...sorted])
         setActiveMag(sorted[0])
      })
   }, [element])

   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(' ')
   }, [])

   useEffect(() => {
      setCounter(counterDefault)
   }, [])

   const handleImageClick = (mag: IPoppulatedMag) => {
      setActiveMag(mag)
   }

   return (
      <div style={{ height: 1435 }}>
         <div className='flex column around w100' style={{ height: 930 }}>
            <Popup
               trigger={
                  <div
                     style={{
                        width: '55%',
                     }}
                  >
                     {activeMag && activeMag.pages && <img src={activeMag.pages[0].value} alt='' className='w100' />}
                  </div>
               }
               modal
               closeOnDocumentClick
               open={open}
               onClose={closeModal}
               onOpen={openModal}
            >
               {activeMag && activeMag.pages && <PagesReader close={closeModal} pages={activeMag.pages.map((page) => page.value)} />}
            </Popup>
         </div>

         <ProjetCarousel items={mags} onImageClick={handleImageClick} />
      </div>
   )
}
